import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-low-consumption-grid-item',
    templateUrl: './issues-low-consumption-grid-item.component.html',
})
export class IssuesLowConsumptionComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['lowConsumptionPage']) {
                    this.page = +queryParams['lowConsumptionPage'];
                } else { this.page = 1 }
            }));

        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestBillDate);
        let yearString = date.getFullYear().toString();
        if (yearString === "1" || item.latestBillDate == null) {
            return false;
        } else {
            return true;
        }
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getLowConsumptionDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesLowConsumptionComponentResolved.next(false); }
        }, error => this.dataService.issuesLowConsumptionComponentResolved.next(false)
        )
    }

    onInfoClick() {
        swal({
            title: 'Low consumption in last 60 days',
            html: '<p style="text-align: left;">This widget shows meters that have lower consumption than the site average for the relevant utility. Calculations consider the last 60 days using average daily usage.</p>\
            <p style="text-align: left;">Meters installed in a property with an active PAYG or Billing consumer provide you with a view link to the individual consumer view to see in more detail the recent consumption.</p>\
            <p style="text-align: left;">Lower than site average daily usage could be consumer behaviour, or indicative of a fault. Sometimes it may be the consumer’s choice to use the supply less and in some instances it could be that the consumer has their controls set lower than they need.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
